import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GlobalService } from '../../../../../../../global.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProposalInformationService {
  constructor(private http: HttpClient, private global: GlobalService) { }

  public reportURL: string = "report?quoteNo="
  
  public getCoverList(prodCode: string) {
    return this.http.get(this.global.medicalURL + this.global.coverlist + prodCode);
  }


  public city() {
    return this.http.get(this.global.medicalURL + this.global.cityrouting + this.global.selectLang);
  }
  
  public business() {
    return this.http.get(this.global.medicalURL + this.global.businessrouting + this.global.selectLang);
  }

  public getProductList(catCode: string) {
    return this.http.get(this.global.medicalURL + this.global.getProductListRouting + catCode + "?lang=" + this.global.selectLang);
  }

  public getPlanList(prodCode: string) {
    return this.http.get(this.global.medicalURL + this.global.getPlanRouting + "/" + prodCode + "?lang=" + this.global.selectLang);
  }

  public getPlanDetails(prodCode: string) {
    return this.http.get(this.global.medicalURL + this.global.getPlanRouting + "?code=" + prodCode);
  }

  public getBenefitsList(prodCode: string, planCode: string) {
    return this.http.get(this.global.medicalURL + this.global.getBenefitsRouting + "prodCode=" + prodCode + "&planCode=" + planCode + "&lang=" + this.global.selectLang);
  }

  public sendReview(data: any, url: string) {
    return this.http.post(this.global.medicalURL + this.global.sendReview + "?url=" + url, data)
  }

  public reviewQuotation(url:string) {
    return this.http.get(this.global.medicalURL + this.global.sendReview + "/" + url);
  }

  public getQuote(data: any) {
    return this.http.post(this.global.medicalURL + this.global.getQuote + this.global.selectLang, data);
  }

  public updateQuote(data: any) {
    return this.http.put(this.global.medicalURL + this.global.getQuote + this.global.selectLang, data);
  }

  public getCategory() {
    return this.http.get(this.global.medicalURL + this.global.getCategory + this.global.selectLang);
  }
  
  public findCustomer(data:any) {
    return this.http.get(this.global.medicalURL + this.global.customer + "/" + data);
  }

  public getQuotationDetail(quoteNo: any) {
    return this.http.get(this.global.medicalURL + this.global.quotationDetail + quoteNo)
  }

  public getQuestions() {
    return this.http.get(this.global.medicalURL + this.global.question)
  }

  public submitToActuary(data: any) {
    return this.http.post(this.global.medicalURL + this.global.sentActuary, data);
  }

  public slagAge() {
    return this.http.get(this.global.medicalURL + this.global.ageslab)
  }

  public report(quoteNo: string, type: string) {
    return this.http.get(this.global.medicalURL + this.reportURL + quoteNo + "&type=" + type)
  }

  //////////// Upload Documents ///////////
  public getDocumentType() {
    return this.http.post(this.global.medicalURL + this.global.medicalDocumentType,{})
  }
  viewDocument(data): Observable<any> {
    return this.http.post<any>(this.global.medicalURL + this.global.medicalViewDocument, data)
  }
  deleteDocument(data): Observable<any> {
    return this.http.post<any>(this.global.medicalURL + this.global.medicalDeleteDocument, data)
  }
  policyConversation(data): Observable<any> {
    return this.http.post<any>(this.global.uploadPageURL + this.global.payMedical, data)
  }
  updateCustomerCode(data): Observable<any> {
    return this.http.post<any>(this.global.uploadPageURL + this.global.updateCustomerCode, data)
  }
  uploadFile(obj:any): Observable<any> {
    return this.http.post(this.global.medicalURL + this.global.medicaldmsupload, obj, {
      reportProgress: true,
      observe: 'events'
    })
  }

  // Group Services
  public saveCorporateInformation(data: any) {
    return this.http.post(this.global.medicalURL + 'saveCorporate', data)
  }

  public saveCorporatePlanMember(data: any) {
    return this.http.post(this.global.medicalURL + 'savePlans', data)
  }
}